import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsProductsList from "./en-us/products-list.json";

export const localizationEnUsMarketplace = {
  ...localizationEnUsHeader,
  ...localizationEnUsProductsList,
};
